import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

export const useTabNavigation = (paramName: string, defaultValue?: string) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab = searchParams.get(paramName) ?? defaultValue;

  const setActiveTab = useCallback(
    (newTab: string) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set(paramName, newTab);
          return next;
        },
        { replace: true },
      );
    },
    [paramName, setSearchParams],
  );

  return [activeTab, setActiveTab] as const;
};
